import React, { useEffect, useRef } from "react";
import {
  DEFAULT_PREVIEW_SECTION,
  getPreviewBlockDisplay,
  getPreviewRegionStyle,
} from "./publicViewThemeUtils";

export default function PublicViewPreviewContent({
  auctionDetail,
  previewSection = DEFAULT_PREVIEW_SECTION,
  previewContextSource = "currentPlayer",
  emphasizePreviewRegions = false,
}) {
  const pvDisplay = (blockKey) =>
    getPreviewBlockDisplay(previewSection, blockKey, previewContextSource);
  const pvRegionStyle = (region) =>
    getPreviewRegionStyle(
      previewSection,
      region,
      emphasizePreviewRegions,
      previewContextSource,
    );
  const rootRef = useRef(null);

  useEffect(() => {
    const root = rootRef.current;
    if (!root) return;

    root.querySelectorAll("a[href]").forEach((link) => {
      link.setAttribute("tabindex", "-1");
      link.setAttribute("aria-disabled", "true");
      link.addEventListener("click", preventInteraction);
    });

    root.querySelectorAll("button").forEach((button) => {
      button.disabled = true;
    });

    return () => {
      root.querySelectorAll("a[href]").forEach((link) => {
        link.removeEventListener("click", preventInteraction);
      });
    };
  }, []);

  return (
    // <div className="cuspre body">
    <div className="content-wrapper pv-preview-noninteractive" ref={rootRef}>
      <style>{`
        .pv-preview-noninteractive a,
        .pv-preview-noninteractive button {
          pointer-events: none;
          cursor: default;
        }
        .player-section,
        .teams-section,
        .auction-timing-container,
        .teams-grid,
        .players-grid {
          transition: opacity 0.25s ease, transform 0.25s ease;
          transform-origin: center top;
        }
      `}</style>
      <div
        className="player-section"
        style={pvRegionStyle("playerSection")}
      >
        <div className="section-header">
          <div className="league-logo">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/auction/1773821320_35457.png"
              alt="ACL"
            />
          </div>

          <h1>Super Cricket League</h1>

          <div className="sponsor-logo">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/sponsor/1767033128769-927444622.png"
              style={{ borderRadius: "5px" }}
              id="spn_lg_1"
              className="spn_lg"
            />
          </div>
        </div>
        <div
          className="auction-timing-container"
          id="auction-timing-container"
          data-pv-preview-block="auctionTiming"
          style={{
            display: pvDisplay("auctionTiming"),
            ...pvRegionStyle("timerSection"),
          }}
        >
          <div className="timing-header">
            <h2>Auction Will Start</h2>
            <div className="auction-date" id="auction-date">
              Sunday, June 14, 2026 at 08:00 PM
            </div>
          </div>
          <div className="countdown-timer" id="auction-countdown">
            <div className="time-unit">
              <span className="time-value" id="days">
                01
              </span>
              <span className="time-label">Days</span>
            </div>
            <div className="time-unit">
              <span className="time-value" id="hours">
                01
              </span>
              <span className="time-label">Hours</span>
            </div>
            <div className="time-unit">
              <span className="time-value" id="minutes">
                10
              </span>
              <span className="time-label">Minutes</span>
            </div>
            <div className="time-unit">
              <span className="time-value" id="seconds">
                30
              </span>
              <span className="time-label">Seconds</span>
            </div>
          </div>
          <div className="timing-message">
            <p>Get ready for an exciting auction!</p>
          </div>
        </div>

        <div
          className="timer-container"
          data-pv-preview-block="bidTimer"
          style={{ display: pvDisplay("bidTimer") }}
        >
          <div className="timer-text" id="countdown-timer">
            20
          </div>
        </div>

        <div
          className="player-card-main"
          data-pv-preview-block="currentPlayer"
          style={{ display: pvDisplay("currentPlayer") }}
        >
          <div className="player-animation-container">
            <div className="bat-animation" style={{ display: "none" }}></div>
            <div className="ball-animation" style={{ display: "none" }}></div>
          </div>
          <div className="player-main-category-tag">Gold</div>

          <div className="player-header-main">
            <div className="player-number-main">47</div>
            <div className="player-image-main">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_47.jpg"
                alt="Player"
              />
            </div>
            <div className="player-info-main">
              <h2 className="player-name-main">PUNEET AGARWAL</h2>
              <div className="player-details-main">
                <p className="specf_1 aaa">RIGHTHAND BATSMEN</p>
                <p className="specf_2">RIGHT ARM MEDIUM FAST</p>
              </div>
            </div>
          </div>
          <div className="player-jodi-header-main" style={{ display: "none" }}>
            <div className="player-number-main">47</div>
            <div className="jodi-container">
              <div className="jodi-images">
                <div className="player-image-wrapper">
                  <img src="new2025/images/player.jpg" alt="Player 1" />
                </div>
                <div className="player-image-wrapper">
                  <img src="new2025/images/player.jpg" alt="Player 2" />
                </div>
              </div>
              <div className="jodi-info">
                <div className="player-info-main">
                  <h2 className="player-name-main">PUNEET AGARWAL</h2>
                  <div className="player-details-main">
                    <p className="specf_1 aaa">RIGHTHAND BATSMEN</p>
                    <p className="specf_2">RIGHT ARM MEDIUM FAST</p>
                  </div>
                </div>
                <div className="jodi-info-connector">
                  <span>&amp;</span>
                </div>
                <div className="player-info-main">
                  <h2 className="player-name-main">PUNEET AGARWAL</h2>
                  <div className="player-details-main">
                    <p className="specf_1 aaa">RIGHTHAND BATSMEN</p>
                    <p className="specf_2">RIGHT ARM MEDIUM FAST</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="bid-parent-container-main">
            <div className="bid-container-main">
              {/* <!-- <div className="base-value-container">
              <span className="base-value-label">Base</span>
              <span className="base-value-amount">2000000</span>
            </div> --> */}
              <div className="base-value-container-main">
                <div className="bidding-team-main">
                  <img
                    src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1738606479_97355.png"
                    alt="CSK"
                    className="team-logo-main bidding-image"
                    style={{ display: "block" }}
                  />
                  {/* <img
                  src="https://superplayerauction.com/new2025/images/hammer2.png"
                  alt="No Team"
                  className="hammer-icon-main"
                  style={{ display: "none" }}
                /> */}
                  <div className="bid-divider-main"></div>
                </div>
                <div className="bid-area-main">
                  <div className="current-bid-main">
                    <div className="bid-label-main">Current Bid</div>
                    <div className="bid-amount-main">500</div>
                  </div>
                </div>
              </div>
            </div>

            <div className="team-name-main">
              <span className="team-text">NORTH SUPERIORS</span>
              <div className="team-name-underline"></div>
            </div>

            <div className="sold-content" style={{ display: "none" }}></div>
          </div>
          <table
            className="player-stats-table"
            style={{ display: "none" }}
          ></table>
        </div>
      </div>

      <div
        className="teams-section"
        data-pv-preview-block="teamList"
        style={{
          display: pvDisplay("teamList"),
          ...pvRegionStyle("teamsSection"),
        }}
      >
        <div className="team-headers">
          <div className="section-header">
            <div className="header-controls">
              <div className="left-controls">
                {/* <nav className="tab-navigation">
                  <span className="active">TEAMS</span>
                  <span className="">PLAYERS</span>
                </nav> */}
                <nav className="tab-navigation">
                  <a href="#" className="active">
                    TEAMS
                  </a>
                  <a href="#">PLAYERS</a>
                </nav>
              </div>
              <div className="stats" style={{ display: "flex" }}>
                <div className="stat-item sold-stat">
                  SOLD : <span id="soldcnt">57</span>
                </div>
                <div className="stat-item unsold-stat">
                  UNSOLD : <span id="unsoldcnt">3</span>
                </div>
                <div className="stat-item avl-stat">
                  AVL : <span id="avlcnt">26</span>
                </div>
                <div className="sound-control" style={{ display: "block" }}>
                  <i className="fas fa-volume-up"></i>
                </div>
                <div
                  className="teams-filters"
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <div className="sort-by">
                    <select id="teamSortSelect" disabled>
                      <option value="">Sort By</option>
                      <option value="default">Default</option>
                      <option value="name">Name</option>
                      <option value="balance_high">Balance-high</option>
                      <option value="balance_low">Balance-low</option>
                      <option value="max_high">Max-high</option>
                      <option value="max_low">Max-low</option>
                      <option value="plno">No. of players</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="player-filters" style={{ display: "none" }}>
                <button
                  className="filter-btn active"
                  data-filter="all"
                  type="button"
                  disabled
                >
                  All
                </button>
                <button
                  className="filter-btn avl-filter"
                  data-filter="available"
                  type="button"
                  disabled
                >
                  AVL
                </button>
                <button
                  className="filter-btn sold-filter"
                  data-filter="sold"
                  type="button"
                  disabled
                >
                  SOLD
                </button>
                <button
                  className="filter-btn unsold-filter"
                  data-filter="unsold"
                  type="button"
                  disabled
                >
                  UNSOLD
                </button>
                <div className="sort-by">
                  <select id="sortSelect" disabled>
                    <option value="">Sort By</option>
                    <option value="number">By Number</option>
                    <option value="name">Name</option>
                    <option value="tag">Tag</option>
                    <option value="category">Category</option>
                  </select>
                </div>
                <div
                  className="column-visibility-dropdown"
                  style={{ display: "none" }}
                >
                  <button className="column-visibility-btn">
                    <i className="fas fa-columns"></i>
                  </button>
                  <div className="column-visibility-content">
                    <div className="dropdown-header">Column Visibility</div>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="pno" />
                      <span className="checkmark"></span>
                      <span className="label-text">P.NO</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="name" />
                      <span className="checkmark"></span>
                      <span className="label-text">NAME</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="age" />
                      <span className="checkmark"></span>
                      <span className="label-text">AGE</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="category" />
                      <span className="checkmark"></span>
                      <span className="label-text">CATEGORY</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="specification" />
                      <span className="checkmark"></span>
                      <span className="label-text">SPECIFICATION</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="specification2" />
                      <span className="checkmark"></span>
                      <span className="label-text">SPECIFICATION 2</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="specification3" />
                      <span className="checkmark"></span>
                      <span className="label-text">SPECIFICATION 3</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="team" />
                      <span className="checkmark"></span>
                      <span className="label-text">TEAM</span>
                    </label>
                    <label className="modern-checkbox">
                      <input type="checkbox" data-column="points" />
                      <span className="checkmark"></span>
                      <span className="label-text">POINTS</span>
                    </label>
                  </div>
                </div>
                <i className="fas fa-list" id="viewToggle"></i>
              </div>
            </div>
          </div>
          <div
            className="section-header section-header-2"
            style={{ display: "none" }}
          >
            <div className="team-sub-header" style={{ display: "flex" }}>
              <div className="team-sub-header-item">
                <span>TEAMS</span>
              </div>
              <div className="team-sub-header-item">
                <span>Team</span>
              </div>
            </div>
            <div className="player-sub-header" style={{ display: "none" }}>
              <div className="team-navigation" style={{ display: "none" }}>
                <i
                  className="fas fa-chevron-left prev-team"
                  title="Previous Team"
                  style={{
                    display: "none",
                    opacity: "1",
                    cursor: "pointer",
                  }}
                ></i>
                <div className="selected-team-title"></div>
                <i
                  className="fas fa-chevron-right next-team"
                  title="Next Team"
                  style={{
                    display: "none",
                    opacity: "1",
                    cursor: "pointer",
                  }}
                ></i>
              </div>
              <div className="player-count-display">
                <span className="player-count-value" id="player-count">
                  86
                </span>
              </div>
              <div className="category-filters">
                <button
                  className="category-btn active"
                  data-category="all"
                  type="button"
                  disabled
                >
                  ALL
                </button>
                <button
                  className="category-btn"
                  data-category="53761"
                  type="button"
                  disabled
                >
                  A
                </button>
                <button
                  className="category-btn"
                  data-category="53762"
                  type="button"
                  disabled
                >
                  B
                </button>
                <button
                  className="category-btn"
                  data-category="53763"
                  type="button"
                  disabled
                >
                  C
                </button>
                <button
                  className="category-btn"
                  data-category="no-category"
                  type="button"
                  disabled
                >
                  No category
                </button>
              </div>
            </div>
          </div>
        </div>
        <div
          className="teams-grid active normal-cards"
          data-pv-preview-block="teamsGrid"
          style={{
            display: pvDisplay("teamsGrid"),
            ...pvRegionStyle("teamsGrid"),
          }}
        >
          <div className="team-card" data-id="168321">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1738606435_9157.png"
              alt="DOMINATORS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>DOMINATORS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">18</div>
                  <div className="bid-item total">
                    <span className="value">90500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">90500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">0</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168322">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1738606479_97355.png"
              alt="NORTH SUPERIORS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>NORTH SUPERIORS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">15</div>
                  <div className="bid-item total">
                    <span className="value">190000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>
                    <span className="value">189000</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">1000</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168324">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1738606609_98361.png"
              alt="RISING ROYAL RANGERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>RISING ROYAL RANGERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">1</div>
                  <div className="bid-item total">
                    <span className="value">99000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91000</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8000</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168340">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908293692-585676580.jpg"
              alt="GPE TITANS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>GPE TITANS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">1</div>
                  <div className="bid-item total">
                    <span className="value">98500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">90500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8000</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168336">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908249011-220393673.jpg"
              alt="SHAGUN TIGERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>SHAGUN TIGERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">0</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168332">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908188635-38554328.jpg"
              alt="NAYA BAZAAR HITTERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>NAYA BAZAAR HITTERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">0</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168323">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1738606571_90546.png"
              alt="TIGERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>TIGERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">6</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">94500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">5500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168333">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908150069-446745053.jpg"
              alt="MAYA INDIANS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>MAYA INDIANS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">0</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168334">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908264564-225326869.jpg"
              alt="SHINGVI HURRICANES"
              className="team-logo"
            />
            <div className="team-details">
              <h3>SHINGVI HURRICANES</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">2</div>
                  <div className="bid-item total">
                    <span className="value">99000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">7500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168337">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908172255-349096038.jpg"
              alt="MANGALAM MASTERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>MANGALAM MASTERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">1</div>
                  <div className="bid-item total">
                    <span className="value">99500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8000</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168344">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908393344-739958684.jpg"
              alt="Kutch Highways Warriors"
              className="team-logo"
            />
            <div className="team-details">
              <h3>Kutch Highways Warriors</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">1</div>
                  <div className="bid-item total">
                    <span className="value">99500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8000</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168338">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908216274-907714434.jpg"
              alt="RAMESHLAL SUPERSTARS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>RAMESHLAL SUPERSTARS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">0</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168343">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908374192-2635919.jpg"
              alt="Vinayak Strikers"
              className="team-logo"
            />
            <div className="team-details">
              <h3>Vinayak Strikers</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">0</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168330">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1767788132_58696.png"
              alt="TITANS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>TITANS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">0</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168339">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908131992-45866167.jpg"
              alt="MANTRA CHALLENGERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>MANTRA CHALLENGERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">2</div>
                  <div className="bid-item total">
                    <span className="value">98500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91000</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">7500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168342">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908315098-378564643.jpg"
              alt="Eklavya Challengers"
              className="team-logo"
            />
            <div className="team-details">
              <h3>Eklavya Challengers</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">0</div>
                  <div className="bid-item total">
                    <span className="value">100000</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168341">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908344278-169172557.jpg"
              alt="Ratnal Blasters"
              className="team-logo"
            />
            <div className="team-details">
              <h3>Ratnal Blasters</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">1</div>
                  <div className="bid-item total">
                    <span className="value">98500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">90500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8000</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168335">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1773908232470-751354188.jpg"
              alt="RSG RISERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>RSG RISERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">8</div>
                  <div className="bid-item total">
                    <span className="value">98500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">94000</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">4500</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="team-card" data-id="168320">
            <img
              src="https://mscsuper.blr1.digitaloceanspaces.com/teams/1738606405_7783.png"
              alt="JS SMASHERS"
              className="team-logo"
            />
            <div className="team-details">
              <h3>JS SMASHERS</h3>
              <div className="bid-info">
                <div className="bid-flex">
                  <div className="bid-item current-bid">1</div>
                  <div className="bid-item total">
                    <span className="value">99500</span>
                    <span className="unit"></span>
                  </div>
                </div>
                <div className="bid-flex">
                  <div className="bid-item max-bid">
                    <span className="label">Max</span>{" "}
                    <span className="value">91500</span>
                    <span className="unit"></span>
                  </div>
                  <div className="bid-item reserve">
                    <span className="label">Res</span>{" "}
                    <span className="value">8000</span>
                    <span className="unit"></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="team-players show-team-cat" style={{ display: "none" }}>
          <div className="team-cat-list">
            <div className="team-cat-item">
              <div className="team-cat-name">
                A: <span className="team-cat-count">0</span>/
                <span className="team-cat-plno">0</span>
              </div>
            </div>
            <div className="team-cat-item">
              <div className="team-cat-name">
                B: <span className="team-cat-count">0</span>/
                <span className="team-cat-plno">0</span>
              </div>
            </div>
            <div className="team-cat-item">
              <div className="team-cat-name">
                C: <span className="team-cat-count">0</span>/
                <span className="team-cat-plno">0</span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number">70</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_70.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>VIVEK SINGHAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=140&amp;n=2060"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item abc">Points : 1000</p>
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
                <p className="detail-item">null</p>
              </div>
            </div>
          </div>
        </div>
        <div
          className="players-grid"
          data-pv-preview-block="playersGrid"
          style={{
            display: pvDisplay("playersGrid"),
            ...pvRegionStyle("playersGrid"),
          }}
        >
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">1</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/1774594556055-597489266.png"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>KULDEEP SINGH</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=2&amp;n=818"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">Age : 39 Yrs.</p>
              </div>
              <div className="team-strip">
                <span className="team-name">GPE TITANS</span>
                <span className="team-points abcdx_0">
                  1500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-owner">
            <div className="player-category-indicator status-unsold-indicator"></div>
            <div className="player-list-number status-unsold-indicator">2</div>
            <div className="player-list-owner-tag">Co-Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/1773822625769-348960600.png"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <h3>Amar Kadam</h3>
              <div className="details-scroll">
                <p className="detail-item">RHB</p>
                <p className="detail-item">Age : 23 Yrs.</p>
              </div>
              <div className="player-unsold-strip">UNSOLD</div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">3</div>
            <div className="player-list-owner-tag">Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_3.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>SUSHIL GARG</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=6&amp;n=854"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM FAST</p>
                <p className="detail-item">Age : 25 Yrs.</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">4</div>
            <div className="player-list-owner-tag">Vice-Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_4.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>SUMIT CHACHA</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=8&amp;n=872"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">Age : 24 Yrs.</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">5</div>
            <div className="player-list-owner-tag">Icon</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_5.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>BASANT AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=10&amp;n=890"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">Age : 28 Yrs.</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">6</div>
            <div className="player-list-owner-tag">Retained</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_6.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AJNESH AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=12&amp;n=908"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">Age : 21 Yrs.</p>
                <p className="detail-item">BASE VALUE: 3000</p>
              </div>
              <div className="team-strip">
                <span className="team-name">Ratnal Blasters</span>
                <span className="team-points abcdx_0">
                  1500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">7</div>
            <div className="player-list-owner-tag">Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_7.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AAKASH AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=14&amp;n=926"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">8</div>
            <div className="player-list-owner-tag">Co-Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_8.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AAKASH SINGHAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=16&amp;n=944"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">9</div>
            <div className="player-list-owner-tag">Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_9.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">A</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>ANAND GARG</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=18&amp;n=962"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">10</div>
            <div className="player-list-owner-tag">Vice-Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_10.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>ANAND JINDAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=20&amp;n=980"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">11</div>
            <div className="player-list-owner-tag">Icon</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_11.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AJAY JAIN</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=22&amp;n=998"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM SPIN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">12</div>
            <div className="player-list-owner-tag">Retained</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_12.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AMIT AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=24&amp;n=1016"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">13</div>
            <div className="player-list-owner-tag">Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_13.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AMIT AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=26&amp;n=1034"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">14</div>
            <div className="player-list-owner-tag">Co-Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_14.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AMIT BANSAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=28&amp;n=1052"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">15</div>
            <div className="player-list-owner-tag">Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_15.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AMIT GARG</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=30&amp;n=1070"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">LEFT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">16</div>
            <div className="player-list-owner-tag">Vice-Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_16.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>AMIT AGARWAL(BSV)</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=32&amp;n=1088"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-owner">
            <div className="player-category-indicator status-unsold-indicator"></div>
            <div className="player-list-number status-unsold-indicator">17</div>
            <div className="player-list-owner-tag">Icon</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_17.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <h3>ANURAG AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="player-unsold-strip">UNSOLD</div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">18</div>
            <div className="player-list-owner-tag">Retained</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_18.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">B</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>ARPIT MITTAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=36&amp;n=1124"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">19</div>
            <div className="player-list-owner-tag">Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_19.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">C</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>ARVIND JI</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=38&amp;n=1142"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">Age : 24 Yrs.</p>
              </div>
              <div className="team-strip">
                <span className="team-name">TIGERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">20</div>
            <div className="player-list-owner-tag">Co-Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_20.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold">C</div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>ARYAMAN AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=40&amp;n=1160"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">Age : 26 Yrs.</p>
              </div>
              <div className="team-strip">
                <span className="team-name">TIGERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">21</div>
            <div className="player-list-owner-tag">Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_21.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>DEEPAK AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=42&amp;n=1178"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">TIGERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">22</div>
            <div className="player-list-owner-tag">Vice-Captain</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_22.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>DEEPAK GARG</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=44&amp;n=1196"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">TIGERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">23</div>
            <div className="player-list-owner-tag">Icon</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_23.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>DEEPAK MAHAJAN</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=46&amp;n=1214"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">TIGERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">24</div>
            <div className="player-list-owner-tag">Retained</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_24.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>DHAWAL BANSAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=48&amp;n=1232"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">TIGERS</span>
                <span className="team-points abcdx_0">
                  0<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">25</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_25.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>DINESH JI</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=50&amp;n=1250"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">LEFT HAND BATSMEN</p>
                <p className="detail-item">LEFT ARM SPIN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">26</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_26.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>DIVYAM AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=52&amp;n=1268"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">Kutch Highways Warriors</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">27</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_27.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>GOURAV MITTAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=54&amp;n=1286"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">28</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_28.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>HAPPY MITTAL</h3>
              <div className="details-scroll">
                <p className="detail-item">LEFT HAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">29</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_29.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>HARISH AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=58&amp;n=1322"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">30</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_30.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>HITESH AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=60&amp;n=1340"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">JS SMASHERS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">31</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_31.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>JAYANT GARG</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">32</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_32.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>JITENDER SINGHAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">33</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_33.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>KALPESH BANSAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=66&amp;n=1394"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">34</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_34.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>KANNAP GOYAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">35</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_35.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>MOHIT AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=70&amp;n=1430"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">MANTRA CHALLENGERS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">36</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_36.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>MRIDUL GOYAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-unsold">
            <div className="player-category-indicator status-unsold-indicator"></div>
            <div className="player-list-number status-unsold-indicator">38</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_38.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>NAVEEN MITTAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
                <p className="detail-item">Age : 25 Yrs.</p>
              </div>
              <div className="player-unsold-strip">UNSOLD</div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">40</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_40.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>NEERAJ GOYAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=80&amp;n=1520"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">MANTRA CHALLENGERS</span>
                <span className="team-points abcdx_0">
                  1000<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">41</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_41.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>NITISH AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM OFF SPIN</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">42</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_42.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>PANKAJ BANSAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">43</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_43.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>PANKAJ GARG</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">44</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_44.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>PAWAN GUPTA</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=88&amp;n=1592"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">45</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_45.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>PAWAN GOYAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=90&amp;n=1610"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">46</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_46.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>PRAMOD GARG</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=92&amp;n=1628"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">47</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_47.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>PUNEET AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">48</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_48.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>PUNIT GARG</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=96&amp;n=1664"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">49</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_49.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>RAHUL GUPTA</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=98&amp;n=1682"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">50</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_50.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>RAHUL AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">51</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_51.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>RAHUL BAZAARI</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">52</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_52.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>RAKESH GOYAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">53</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_53.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>RAVI AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=106&amp;n=1754"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">LEFT HAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">54</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_54.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>RAVI AGARWAL CHINU</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=108&amp;n=1772"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">55</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_55.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>RONIT AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=110&amp;n=1790"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">56</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_56.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>RUDRAJ GARG</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=112&amp;n=1808"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">57</div>
            <div className="player-list-owner-tag">Owner</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_57.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>SANJAY GUPTA</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=114&amp;n=1826"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  2000<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">58</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_58.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>SARANSH AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=116&amp;n=1844"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">59</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_59.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>SOURABH AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">60</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_60.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>SOURABH GOYAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=120&amp;n=1880"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">61</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_61.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>SUDHIR AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">62</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_62.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>SUMIT BANSAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=124&amp;n=1916"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">63</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_63.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>TANMAY MITTAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=126&amp;n=1934"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">64</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_64.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>TARUN MITTAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=128&amp;n=1952"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">65</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_65.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>TUSHAR GUPTA</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">66</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_66.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>VARUN AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">67</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_67.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>MANDEEP GARG</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">68</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_68.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>VIKAS GARG</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">69</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_69.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>VIPIN AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=138&amp;n=2042"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">SHINGVI HURRICANES</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">70</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_70.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>VIVEK SINGHAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=140&amp;n=2060"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM</p>
              </div>
              <div className="team-strip">
                <span className="team-name">RISING ROYAL RANGERS</span>
                <span className="team-points abcdx_0">
                  1000<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">71</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_71.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>YASH AGARWAL</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=142&amp;n=2078"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM FAST</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">72</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_72.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>YASHOVARDHAN MITTAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">73</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_73.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>Bipin Parmar</h3>
              <div className="details-scroll"></div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">74</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_74.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>Nikhil Bhambani</h3>
              <div className="details-scroll">
                <p className="detail-item">Left Hand Opener</p>
                <p className="detail-item">Left Arm Fast</p>
                <p className="detail-item">aaaaa</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">75</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_75.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>Bhawani Singh Bhati</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=150&amp;n=2150"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll"></div>
              <div className="team-strip">
                <span className="team-name">SHINGVI HURRICANES</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">76</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_76.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>Dilip Singh</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=152&amp;n=2168"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">Left Hand</p>
                <p className="detail-item">Right Arm Fast</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">77</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/club_c2_1776234651.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>madho singh</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=154&amp;n=2186"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">Batting All Rounder</p>
                <p className="detail-item">Left Arm Fast</p>
                <p className="detail-item">lokesh</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">78</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_78.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>Hari</h3>
              <div className="details-scroll"></div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">79</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_79.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>Shiva</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=158&amp;n=2222"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll"></div>
              <div className="team-strip">
                <span className="team-name">MANGALAM MASTERS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">80</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_80.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>Anil kumar</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=160&amp;n=2240"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">Right Hand Batsman</p>
                <p className="detail-item">Spinner</p>
              </div>
              <div className="team-strip">
                <span className="team-name">NORTH SUPERIORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">81</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_81.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>Mukesh</h3>
              <div className="details-scroll"></div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">82</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_82.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>Vipin Mishra</h3>
              <div className="details-scroll">
                <p className="detail-item">Right Hand Batsman</p>
                <p className="detail-item">Left Arm Spin</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">84</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_84.png"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>SHRIRAM AGARWAL</h3>
              <div className="details-scroll">
                <p className="detail-item">RIGHTHAND BATSMEN</p>
                <p className="detail-item">RIGHT ARM MEDIUM FAST</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">85</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/60000_85.png"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>vijay</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=170&amp;n=2330"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">Age : 23 Yrs.</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">86</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/1763745329662-436078397.jpg"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>Vinay Agarwal</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=172&amp;n=2348"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll">
                <p className="detail-item">Age : 16 Yrs.</p>
                <p className="detail-item">aro</p>
              </div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card">
            <div className="player-category-indicator"></div>
            <div className="player-list-number">87</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/1775203076030-940183744.png"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <h3>Vinay Agarwal</h3>
              <div className="details-scroll">
                <p className="detail-item">Age : 16 Yrs.</p>
                <p className="detail-item">aro</p>
              </div>
              <div className="player-strip"></div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">88</div>
            <div className="player-image-container">
              <img src="new2025/images/player.jpg?a" alt="Player" />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>Singh</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=176&amp;n=2384"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll"></div>
              <div className="team-strip">
                <span className="team-name">DOMINATORS</span>
                <span className="team-points abcdx_0">
                  1000<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
          <div className="player-list-card has-team">
            <div className="player-category-indicator status-sold-indicator"></div>
            <div className="player-list-number status-sold-indicator">89</div>
            <div className="player-image-container">
              <img
                src="https://mscsuper.blr1.digitaloceanspaces.com/playersphoto/1775215006590-633376448.webp"
                alt="Player"
              />
              <div className="player-category-label category-gold"></div>
            </div>
            <div className="player-list-details">
              <div className="player-list-name-row">
                <h3>Bhawani</h3>
                <a
                  className="player-list-poster-download"
                  href="https://superplayerauction.com/manage/playercard/?actid=60000&amp;p=178&amp;n=2402"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Download player poster"
                  aria-label="Download player poster"
                >
                  <i className="fas fa-download"></i>
                </a>
              </div>
              <div className="details-scroll"></div>
              <div className="team-strip">
                <span className="team-name">RSG RISERS</span>
                <span className="team-points abcdx_0">
                  500<span className="pointtyp"></span>
                </span>
              </div>
            </div>
          </div>
        </div>
        <div className="players-list-view" style={{ display: "none" }}>
          <div
            className="list-view-header"
            style={{ gridTemplateColumns: "40px 220px 150px 220px 100px" }}
          >
            <div className="header-cell pno">P.NO</div>
            <div className="header-cell name">NAME</div>
            <div className="header-cell age" style={{ display: "none" }}>
              AGE
            </div>
            <div className="header-cell category">CATEGORY</div>
            <div className="header-cell specification">SPECIFICATION</div>
            <div
              className="header-cell specification2"
              style={{ display: "none" }}
            >
              SPECIFICATION 2
            </div>
            <div
              className="header-cell specification3"
              style={{ display: "none" }}
            >
              SPECIFICATION 3
            </div>
            <div className="header-cell team" style={{ display: "none" }}>
              TEAM
            </div>
            <div className="header-cell points"></div>
          </div>
          <div className="list-view-body">
            {/* <!-- Example Player Row --> */}
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
            <div
              className="player-row"
              style={{
                gridTemplateColumns: "40px 220px 150px 220px 100px",
              }}
            >
              <div className="cell pno">
                <div className="player-status gold"></div>
                01
              </div>
              <div className="cell name">
                <div className="player-name-container">
                  <img
                    src="new2025/images/player.jpg"
                    alt="Player"
                    className="player-small-img"
                  />
                  <span>AMIT GARG</span>
                </div>
              </div>
              <div className="cell age" style={{ display: "none" }}>
                28
              </div>
              <div className="cell category">
                <span className="category-badge gold">GOLD</span>
              </div>
              <div className="cell specification">
                <div className="spec-list">
                  <span>RIGHTHAND BATSMEN</span>
                </div>
              </div>
              <div className="cell specification2" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>LEFT ARM MEDIUM</span>
                </div>
              </div>
              <div className="cell specification3" style={{ display: "none" }}>
                <div className="spec-list">
                  <span>ALL ROUNDER</span>
                </div>
              </div>
              <div className="cell team" style={{ display: "none" }}>
                SUPER KINGS
              </div>
              <div className="cell points">
                <div className="points-container">
                  <span className="point-value">₹25,000</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    // </div>
  );
}

function preventInteraction(event) {
  event.preventDefault();
  event.stopPropagation();
}
